import { Box, Typography } from "@mui/material";
import React from "react";
import { Colors } from "../../Theme/Theme";

export default function DashBoardWidget({ icon, title, value }) {
  return (
    <Box
      sx={{
        display: "flex", alignItems: "center", gap: 2,
        backgroundColor: Colors.white, border: `1px solid ${Colors.dividerColor}`,
        borderRadius: "12px", p: 2.5, minWidth: 220, flex: "1 1 220px",
        transition: "all 0.2s",
        "&:hover": { boxShadow: "0 4px 20px rgba(37,99,235,0.06)", borderColor: `${Colors.primary}30` },
      }}
    >
      <Box
        sx={{
          width: 44, height: 44, borderRadius: "10px",
          backgroundColor: Colors.blueSoft,
          display: "flex", alignItems: "center", justifyContent: "center", flexShrink: 0,
        }}
      >
        <img src={icon} alt="" style={{ width: 22, height: 22 }} />
      </Box>
      <Box>
        <Typography variant="body2" sx={{ color: Colors.secondaryColor, fontWeight: 500, fontSize: "13px" }}>
          {title}
        </Typography>
        <Typography variant="h6" sx={{ color: Colors.primaryTextColor, fontWeight: 700, fontSize: "18px", lineHeight: 1.2 }}>
          {value}
        </Typography>
      </Box>
    </Box>
  );
}
